import { Club } from '@Models';
import { ClubsState, buildClubsState } from '@Stores/index';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

const initialState: ClubsState = buildClubsState({
  entity: [],
}) satisfies ClubsState as ClubsState;

const myClubsSlice = createSlice({
  name: 'my-clubs',
  initialState,
  reducers: {
    setError(state: ClubsState, action: PayloadAction<string>) {
      state.errorMessage = action.payload;
      state.hasError = true;
    },
    setLoading(state: ClubsState, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    setClubs(state: ClubsState, action: PayloadAction<Club[]>) {
      state.entity = action.payload;
      state.isLoading = false;
      state.hasError = false;
      state.errorMessage = null;
    },
    addClub(state: ClubsState, action: PayloadAction<Club>) {
      state.entity!.push(action.payload);
    },
    updateClub(state: ClubsState, action: PayloadAction<Club>) {
      state.entity = state.entity?.map((club) =>
        club.id === action.payload.id ? action.payload : club,
      ) ?? [action.payload];
    },
  },
});

export default myClubsSlice;
